(function () {
  // Feriados irrenunciables Chile 2026-2027
  // Actualizar cada año: https://www.feriados-chile.cl/
  var HOLIDAYS = [
    '2026-01-01','2026-04-03','2026-04-04','2026-05-01','2026-05-21',
    '2026-06-26','2026-07-16','2026-08-15','2026-09-18','2026-09-19',
    '2026-10-12','2026-10-31','2026-11-01','2026-12-08','2026-12-25',
    '2027-01-01','2027-03-26','2027-03-27','2027-05-01','2027-05-21',
    '2027-06-25','2027-07-16','2027-08-15','2027-09-18','2027-09-19',
    '2027-10-12','2027-10-31','2027-11-01','2027-12-08','2027-12-25'
  ];

  var DAYS = ['Domingo','Lunes','Martes','Miércoles','Jueves','Viernes','Sábado'];
  var MONTHS = ['enero','febrero','marzo','abril','mayo','junio','julio','agosto','septiembre','octubre','noviembre','diciembre'];

  function pad(n) { return n < 10 ? '0' + n : '' + n; }
  function toKey(d) { return d.getFullYear()+'-'+pad(d.getMonth()+1)+'-'+pad(d.getDate()); }
  function isHoliday(d) { return HOLIDAYS.indexOf(toKey(d)) !== -1; }
  function isBusinessDay(d) { var w = d.getDay(); return w !== 0 && w !== 6 && !isHoliday(d); }

  function addBusinessDays(start, days) {
    var r = new Date(start.getTime()), count = 0;
    while (count < days) {
      r.setDate(r.getDate() + 1);
      if (isBusinessDay(r)) count++;
    }
    return r;
  }

  function formatDate(d) {
    return DAYS[d.getDay()] + ' ' + d.getDate() + ' de ' + MONTHS[d.getMonth()];
  }

  function getSantiagoDelivery() {
    var now = new Date(new Date().toLocaleString('en-US', { timeZone: 'America/Santiago' }));
    var today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
    var nowMin = now.getHours() * 60 + now.getMinutes();
    var daysToAdd = (isBusinessDay(today) && nowMin < 9 * 60 + 30) ? 0 : 1;
    return addBusinessDays(today, daysToAdd);
  }

  function updateWidget(container) {
    var checked = container.querySelector('.buho-delivery-radio:checked');
    var resultEl = container.querySelector('.estimated-delivery__result');
    var dateEl = container.querySelector('.estimated-delivery__date');
    var breakdownEl = container.querySelector('.estimated-delivery__breakdown');
    if (!checked) return;

    if (checked.value === 'santiago') {
      if (dateEl) dateEl.innerHTML = '<strong>' + formatDate(getSantiagoDelivery()) + '</strong>';
      if (resultEl) resultEl.style.display = 'flex';
      if (breakdownEl) breakdownEl.style.display = 'none';
    } else {
      if (resultEl) resultEl.style.display = 'none';
      if (breakdownEl) breakdownEl.style.display = 'block';
    }
  }

  function initAll() {
    document.querySelectorAll('.estimated-delivery:not([data-delivery-init])').forEach(function(container) {
      container.setAttribute('data-delivery-init', '1');
      updateWidget(container);
      container.querySelectorAll('.buho-delivery-radio').forEach(function(radio) {
        radio.addEventListener('change', function() { updateWidget(container); });
      });
    });
  }

  function observeCartUpdates() {
    if (!window.MutationObserver) return;
    var observer = new MutationObserver(initAll);
    document.querySelectorAll('.js-contents').forEach(function(el) {
      observer.observe(el, { childList: true });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() { initAll(); observeCartUpdates(); });
  } else {
    initAll();
    observeCartUpdates();
  }

  document.addEventListener('shopify:section:load', function() {
    document.querySelectorAll('.estimated-delivery').forEach(function(el) {
      el.removeAttribute('data-delivery-init');
    });
    initAll();
  });
})();
